import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import PublicLayout from '@/layouts/Public'
import store from '@/store'
import cookies from 'vue-cookies'

const router = createRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/masuk',
      component: MainLayout,
      meta: {
        authRequired: true,
      },
      children: [
        {
          path: '/cancer/breast',
          name: 'Breast Cancer',
          meta: { title: 'Breast Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/skin',
          name: 'Skin Cancer',
          meta: { title: 'Skin Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/tyroid',
          name: 'Tyroid Cancer',
          meta: { title: 'Tyroid Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/miscellaneous',
          name: 'Miscellaneous Cancer',
          meta: { title: 'Miscellaneous Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/sarcoma',
          name: 'Sarcoma Cancer',
          meta: { title: 'Sarcoma Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/lymphoma',
          name: 'Lymphoma Cancer',
          meta: { title: 'Lymphoma Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/salivary-gland',
          name: 'Salivary Gland Cancer',
          meta: { title: 'Salivary Gland Cancer' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/cancer/head-and-neck',
          name: 'Head & Neck',
          meta: { title: 'Head & Neck' },
          component: () => import('./views/istry/pathway'),
        },
        {
          path: '/drugs',
          name: 'Drugs',
          meta: { title: 'Drugs' },
          component: () => import('./views/istry/drugs'),
        },
        {
          path: '/user',
          name: 'User',
          meta: {
            title: 'User',
            requiresSuperAdmin: true,
          },
          component: () => import('./views/istry/user'),
        },
        {
          path: '/admin',
          name: 'Admin',
          meta: {
            title: 'Admin',
            requiresSuperAdmin: true,
          },
          component: () => import('./views/istry/admin'),
        },
        {
          path: '/akun',
          name: 'Manajemen Akun',
          meta: { title: 'Manajemen Akun' },
          component: () => import('./views/akun'),
        },
        {
          path: '/akun/:id',
          name: 'Detail Akun',
          meta: { title: 'Akun' },
          component: () => import('./views/akun/detail'),
        },
      ],
    },

    // System Pages
    {
      path: '/',
      component: AuthLayout,
      meta: { authRequired: false, isAuth: false },
      name: 'auth',
      children: [
        {
          path: '/masuk',
          name: 'masuk',
          meta: {
            title: 'Masuk',
          },
          component: () => import('@/views/auth/login'),
        },
        {
          path: 'register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/forgot-password',
          name: 'Forgot Password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/reset-password',
          name: 'Lupa Password',
          meta: {
            title: 'Lupa Password',
          },
          component: () => import('./views/auth/reset-password'),
        },
        {
          path: '/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },
    {
      path: '/unauthorized',
      component: PublicLayout,
      meta: { authRequired: false },
      children: [
        {
          path: '',
          name: 'Unauthorized',
          meta: { title: 'Unauthorized Access' },
          component: () => import('./views/istry/unauthorized'),
        },
      ],
    },
    {
      path: '/404',
      name: 'route404',
      meta: {
        title: 'Error 404',
      },
      component: () => import('./views/auth/404'),
    },
    {
      path: '/email-approval',
      name: 'Email Approval',
      meta: {
        title: 'Email Approval',
        authRequired: false,
      },
      component: () => import('./views/approval/email.vue'),
    },
    {
      path: '/500',
      meta: {
        title: 'Error 500',
      },
      component: () => import('./views/auth/500'),
    },

    // Redirect to 404
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'route404' },
    },
  ],
})
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.meta.authRequired
  const requiresSuperAdmin = to.meta.requiresSuperAdmin

  // Check if user has access token
  const accessToken = localStorage.getItem('accessToken')
  const storedUserData = localStorage.getItem('userData')

  // If user is going to login page but already has valid token, redirect to main app
  if (to.name === 'masuk' && accessToken && storedUserData) {
    try {
      const userData = JSON.parse(storedUserData)
      if (userData.user) {
        // Initialize store from localStorage
        store.dispatch('user/INITIALIZE_FROM_LOCAL_STORAGE')

        // Redirect based on user role
        const userRole = userData.user.role
        if (userRole === 'siteManager') {
          return next('/eos-monitoring')
        } else if (userRole === 'eos') {
          return next('/monitoring')
        } else if (userRole === 'receptionist') {
          return next('/receptionist')
        } else if (userRole === 'helpDesk') {
          return next('/request')
        } else {
          return next('/cancer/breast')
        }
      }
    } catch (err) {
      console.log('Error parsing stored user data:', err)
      // Clear invalid data and proceed to login
      localStorage.removeItem('accessToken')
      localStorage.removeItem('userData')
    }
  }

  // Always initialize user store from localStorage if user data exists and store is not already populated
  if (storedUserData && !store.getters['user/user'].authorized) {
    store.dispatch('user/INITIALIZE_FROM_LOCAL_STORAGE')
  }

  // Check for authentication requirement
  if (requiresAuth && !accessToken) {
    return next({ name: 'masuk' })
  }

  // Check for superadmin access
  if (requiresSuperAdmin) {
    if (storedUserData) {
      const userData = JSON.parse(storedUserData)

      // Check if user is superadmin
      if (userData.user && userData.user.role === 'superadmin') {
        next() // Allow access
      } else {
        next({ name: 'Unauthorized' }) // Redirect to unauthorized page
      }
    } else {
      next({ name: 'masuk' }) // Redirect to login if no user data
    }
  } else {
    // For regular routes, just proceed
    next()
  }
})

export default router
